import { Component, ComponentRef, EventEmitter, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ToastComponent, ToastService } from '@engie-group/fluid-design-system-angular';
import { AlertMessage } from 'src/app/core/Dtos/alert.entity';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { ToastViewerComponent } from '../toast/toast.component';
import { Router } from '@angular/router';
import { UserData } from 'src/app/core/Dtos/user-data.entity';
import { OktaService } from '@engie-group/ngx-gem-spaas';
import { UserService } from 'src/app/core/user.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  public DisplayLoading: boolean = false;
  public UserData: UserData | null = null;
  public get UserName(): string {
    return this._oktaService.getUserInfo()?.firstName + " " + this._oktaService.getUserInfo()?.lastName;
  }

  public get CurrentTab(): string {
    return window.location.href.indexOf('moweo') != -1 ? "Moweo_Dashboard" : 
            window.location.href.indexOf('mowwl') != -1 ? "Mowwl_Dashboard":
            window.location.href.indexOf('fhc') != -1 ? "FHC_Dashboard" :
            window.location.href.indexOf('retail') != -1 ? "Retail_Dashboard" : 
            window.location.href.indexOf('res') != -1 ? "Res_Dashboard" : "Trader_Dashboard";
  }

  constructor(private _oktaService: OktaService, 
    private _userService: UserService,
    private _alertService: AlertsService,
    private toastService: ToastService,
    private viewContainerRef: ViewContainerRef,
    private router: Router)
  {
    _userService.onNewUser().subscribe(
      userData => this.UserData = userData
    )

    _alertService.onAPICallCountChange.subscribe(m => {
      console.log("API Calls count: " + m);
      this.DisplayLoading = m != 0;
    });

    _alertService.onAlertReceived.subscribe((message: AlertMessage) => {
      const toastRef: ComponentRef<ToastViewerComponent> = this.toastService.open(ToastViewerComponent, {viewContainerRef: this.viewContainerRef});
      toastRef.instance.Title= message.Type.toString();
      toastRef.instance.Message= message.Message;
    });
  }

  NavigateTo(selectedTab: string) {
    if (selectedTab == "Trader_Dashboard")
      this.router.navigate([""]);
    else if (selectedTab == "Moweo_Dashboard")
      this.router.navigate(["moweo"]);
    else if (selectedTab == "Mowwl_Dashboard")
      this.router.navigate(["mowwl"]);
    else if (selectedTab == "FHC_Dashboard")
      this.router.navigate(["fhc"]);
    else if (selectedTab == "Retail_Dashboard")
      this.router.navigate(["retail"]);
    else if (selectedTab == "Res_Dashboard")
      this.router.navigate(["res"]);
  }
}
